// adapt groups from new api to the same format as the one returned by old customer groups api and integrationEmployees meta data api
export const adaptGroupsToStandardFormat = (groups) =>
  groups?.map((item) => ({
    id: item.id,
    value: item.id,
    name: item.displayName,
    label: item.displayName,
    groupType: item.type,
  }))

/** Tenant metadata / Graph may use different casing for the same logical type. */
export const isSharedMailboxGroupType = (groupType) =>
  groupType != null && String(groupType).replace(/\s+/g, '').toLowerCase() === 'sharedmailbox'

/** Customer groups API maps `groupType` → `type` in responses; Graph-adapted rows use `groupType`. */
export const getGroupTypeForFilter = (item) => item?.groupType ?? item?.type

// the new groups api (live data) and the old groups api (shared mailboxes) can both list the same shared mailbox
// thus we join them and keep each id once, preferring the old api entry (it carries name and groupType)
export const joinGroupsWithSharedMailboxes = ({ groups, sharedMailboxesGroups }) => {
  const sharedMailboxes =
    sharedMailboxesGroups?.filter((item) => isSharedMailboxGroupType(getGroupTypeForFilter(item))) ?? []
  const sharedMailboxIds = new Set(sharedMailboxes.map((item) => item.id))
  const graphGroups = (adaptGroupsToStandardFormat(groups) ?? []).filter((item) => !sharedMailboxIds.has(item.id))

  return [...sharedMailboxes, ...graphGroups]
}
